// Centralized TGS sticker file paths
// All animated stickers used throughout the app

export const TGS_STICKERS = {
  // Basic emotions
  CRYING: '/assets/tgs/crying.tgs',
  HAPPY: '/assets/tgs/happy.tgs',
  SLEEPY: '/assets/tgs/sleepy.tgs',
  WAVING: '/assets/tgs/waving.tgs',
  HEART_PINGUIN: '/assets/tgs/heart-penguin.tgs',
  BEAR: '/assets/tgs/bear.tgs',

  // Complex emotions
  ADDICTED: '/assets/tgs/addicted.tgs',
  ARNOLD: '/assets/tgs/arnold.tgs',
  KISS: '/assets/tgs/kiss.tgs',
  LUNCHTIME: '/assets/tgs/lunchtime.tgs',
  ROFL: '/assets/tgs/rofl.tgs',
  WHAAT: '/assets/tgs/whaat.tgs',
  FUN: '/assets/tgs/fun.tgs',

  // Doodles collection
  VOMIT: '/assets/tgs/Doodles2AnimatedSticker.tgs',
  DOODLES_1: '/assets/tgs/Doodles1AnimatedSticker.tgs',
  DOODLES_HOLO_1: '/assets/tgs/DoodlesHoloTest_AgAD-wMAAtI2YUc.tgs',
  DOODLES_HOLO_2: '/assets/tgs/DoodlesHoloTest_AgAD1QQAAtsNYEc.tgs',
  DOODLES_HOLO_3: '/assets/tgs/DoodlesHoloTest_AgAD6gMAAgzxYEc.tgs',
  DOODLES_HOLO_4: '/assets/tgs/DoodlesHoloTest_AgADEwUAAqrNYUc.tgs',
  DOODLES_HOLO_5: '/assets/tgs/DoodlesHoloTest_AgADUwUAAkgfYUc.tgs',
  DOODLES_HOLO_6: '/assets/tgs/DoodlesHoloTest_AgADXAUAAqRRKEc.tgs',
  DOODLES_HOLO_7: '/assets/tgs/DoodlesHoloTest_AgADiwUAAmRZYUc.tgs',
  DOODLES_HOLO_8: '/assets/tgs/DoodlesHoloTest_AgADoQYAAjGuYEc.tgs',
  DOODLES_HOLO_9: '/assets/tgs/DoodlesHoloTest_AgADxQUAAlCGYEc.tgs',

  // Forge result
  FORGE_SUCCESS: '/assets/tgs/forge/forge-success.tgs',
  FORGE_FAIL: '/assets/tgs/forge/forge-fail.tgs',

  // Numbered stickers
  STICKER_01: '/assets/tgs/01.tgs',
  STICKER_02: '/assets/tgs/02.tgs',
  STICKER_03: '/assets/tgs/03.tgs',
  STICKER_04: '/assets/tgs/04.tgs',
  STICKER_05: '/assets/tgs/05.tgs',
  STICKER_06: '/assets/tgs/06.tgs',
  STICKER_07: '/assets/tgs/07.tgs',
  STICKER_08: '/assets/tgs/08.tgs',
  STICKER_09: '/assets/tgs/09.tgs',
  STICKER_10: '/assets/tgs/10.tgs',

  // Pack collection stickers
  PACK_1: '/assets/tgs/pack_1_38654705666_105_5500318549_by_sticker_bot_AgAD7BUAAteQiFI.tgs',
  PACK_2: '/assets/tgs/pack_1_38654705666_105_5500318549_by_sticker_bot_AgADExUAAo6-iVI.tgs',
  PACK_3: '/assets/tgs/pack_1_38654705666_105_5500318549_by_sticker_bot_AgADFhgAAnwsiVI.tgs',
  PACK_4: '/assets/tgs/pack_1_38654705666_105_5500318549_by_sticker_bot_AgADMRgAAkedkFI.tgs',
  PACK_5: '/assets/tgs/pack_1_38654705666_105_5500318549_by_sticker_bot_AgADMRsAAgMLkFI.tgs',
  PACK_6: '/assets/tgs/pack_1_38654705666_105_5500318549_by_sticker_bot_AgADVRcAAilhkVI.tgs',
  PACK_7: '/assets/tgs/pack_1_38654705666_105_5500318549_by_sticker_bot_AgAD_BkAAsIhkVI.tgs',
  PACK_8: '/assets/tgs/pack_1_38654705666_105_5500318549_by_sticker_bot_AgADchkAAi0WkFI.tgs',
  PACK_9: '/assets/tgs/pack_1_38654705666_105_5500318549_by_sticker_bot_AgADhBoAAi0nkVI.tgs',
  PACK_10: '/assets/tgs/pack_1_38654705666_105_5500318549_by_sticker_bot_AgADjxkAAvQtkVI.tgs',
  PACK_11: '/assets/tgs/pack_1_38654705666_105_5500318549_by_sticker_bot_AgADthcAAopKkVI.tgs',
  PACK_12: '/assets/tgs/pack_1_38654705666_105_5500318549_by_sticker_bot_AgADxRYAAsr_iVI.tgs',

  // onboarding extra
  FINAL_ONBOARDING: '/assets/tgs/PoXPudgytestbnalsdfnasdf_AgADKncAAlxeuEk.tgs',
  TEDDIE_STICKER_02: '/assets/tgs/teddie_sticker_02.tgs',
  TEDDIE_EMOJI: '/assets/tgs/teddie_emoji.tgs',
} as const;

// Export individual stickers for easier imports
export const {
  CRYING,
  HAPPY,
  SLEEPY,
  WAVING,
  ADDICTED,
  ARNOLD,
  KISS,
  LUNCHTIME,
  ROFL,
  WHAAT,
  VOMIT,
  DOODLES_1,
  DOODLES_HOLO_1,
  DOODLES_HOLO_2,
  DOODLES_HOLO_3,
  DOODLES_HOLO_4,
  DOODLES_HOLO_5,
  DOODLES_HOLO_6,
  DOODLES_HOLO_7,
  DOODLES_HOLO_8,
  DOODLES_HOLO_9,
  STICKER_01,
  STICKER_02,
  STICKER_03,
  STICKER_04,
  STICKER_05,
  STICKER_06,
  STICKER_07,
  STICKER_08,
  STICKER_09,
  STICKER_10,
  HEART_PINGUIN,
} = TGS_STICKERS;
